import { EditorView } from "@codemirror/view";

export const markdownLinkTheme = EditorView.baseTheme({
    ".cm-magic-markdown-link": {
        "--cm-magic-markdown-link-accent": "var(--content-link)",
        display: "inline-flex",
        maxWidth: "100%",
        alignItems: "center",
        gap: "0.28em",
        verticalAlign: "-0.12em",
        color: "inherit",
        fontWeight: "inherit",
        lineHeight: "inherit",
        textDecorationLine: "underline",
        textDecorationStyle: "dotted",
        textDecorationThickness: "0.08em",
        textDecorationColor:
            "color-mix(in srgb, var(--cm-magic-markdown-link-accent) 34%, transparent)",
        textUnderlineOffset: "0.16em",
        cursor: "pointer",
        transition: "text-decoration-color 120ms ease",
    },
    ".cm-magic-markdown-link:hover": {
        color: "inherit",
        textDecorationLine: "underline",
        textDecorationStyle: "dotted",
        textDecorationColor:
            "color-mix(in srgb, var(--cm-magic-markdown-link-accent) 62%, transparent)",
    },
    ".cm-magic-markdown-link-kind-markdown": {
        "--cm-magic-markdown-link-accent": "var(--cm-define-accent)",
    },
    ".cm-magic-markdown-link-kind-json": {
        "--cm-magic-markdown-link-accent": "var(--syntax-string)",
    },
    ".cm-magic-markdown-link-kind-html, .cm-magic-markdown-link-kind-web": {
        "--cm-magic-markdown-link-accent": "var(--content-link)",
    },
    ".cm-magic-markdown-link-kind-image, .cm-magic-markdown-link-kind-video": {
        "--cm-magic-markdown-link-accent": "var(--cm-content-accent)",
    },
    ".cm-magic-markdown-link-kind-audio": {
        "--cm-magic-markdown-link-accent": "var(--cm-use-accent)",
    },
    ".cm-magic-markdown-link-kind-csv": {
        "--cm-magic-markdown-link-accent": "var(--cm-import-accent)",
    },
    ".cm-magic-markdown-link-kind-code": {
        "--cm-magic-markdown-link-accent": "var(--cm-render-accent)",
    },
    ".cm-magic-markdown-link-kind-pdf, .cm-magic-markdown-link-kind-asset": {
        "--cm-magic-markdown-link-accent": "var(--cm-meta-accent)",
    },
    ".cm-magic-markdown-link-kind-anchor": {
        "--cm-magic-markdown-link-accent": "var(--color-muted-foreground)",
    },
    ".cm-magic-markdown-link-icon": {
        display: "block",
        width: "0.92em",
        height: "0.92em",
        flex: "0 0 auto",
        alignSelf: "center",
        margin: "0",
        padding: "0",
        minWidth: "0.92em",
        maxWidth: "0.92em",
        minHeight: "0.92em",
        maxHeight: "0.92em",
        verticalAlign: "middle",
        color: "var(--cm-magic-markdown-link-accent)",
        opacity: "0.95",
        strokeWidth: "2.1",
    },
    ".cm-magic-markdown-link-favicon": {
        display: "block",
        width: "0.92em",
        height: "0.92em",
        flex: "0 0 auto",
        alignSelf: "center",
        margin: "0",
        padding: "0",
        minWidth: "0.92em",
        maxWidth: "0.92em",
        minHeight: "0.92em",
        maxHeight: "0.92em",
        verticalAlign: "middle",
        borderRadius: "2px",
        objectFit: "cover",
        background:
            "color-mix(in srgb, var(--color-muted-foreground) 8%, transparent)",
        boxShadow:
            "0 0 0 1px color-mix(in srgb, var(--color-muted-foreground) 14%, transparent)",
    },
    ".cm-magic-markdown-link-thumbnail": {
        display: "block",
        width: "1.08em",
        height: "1.08em",
        flex: "0 0 auto",
        alignSelf: "center",
        margin: "0",
        padding: "0",
        minWidth: "1.08em",
        maxWidth: "1.08em",
        minHeight: "1.08em",
        maxHeight: "1.08em",
        verticalAlign: "middle",
        borderRadius: "2px",
        objectFit: "cover",
        background:
            "color-mix(in srgb, var(--color-muted-foreground) 8%, transparent)",
        boxShadow:
            "0 0 0 1px color-mix(in srgb, var(--cm-magic-markdown-link-accent) 22%, transparent)",
    },
    ".cm-magic-markdown-link-label": {
        minWidth: "0",
        overflowWrap: "anywhere",
    },
    ".cm-magic-markdown-refdef": {
        "--cm-magic-markdown-link-accent": "var(--content-link)",
        display: "inline-flex",
        maxWidth: "100%",
        alignItems: "center",
        gap: "0.32em",
        verticalAlign: "-0.12em",
        color: "inherit",
        fontWeight: "inherit",
        lineHeight: "inherit",
        cursor: "pointer",
    },
    ".cm-magic-markdown-refdef-kind-markdown": {
        "--cm-magic-markdown-link-accent": "var(--cm-define-accent)",
    },
    ".cm-magic-markdown-refdef-kind-json": {
        "--cm-magic-markdown-link-accent": "var(--syntax-string)",
    },
    ".cm-magic-markdown-refdef-kind-html, .cm-magic-markdown-refdef-kind-web": {
        "--cm-magic-markdown-link-accent": "var(--content-link)",
    },
    ".cm-magic-markdown-refdef-kind-image, .cm-magic-markdown-refdef-kind-video": {
        "--cm-magic-markdown-link-accent": "var(--cm-content-accent)",
    },
    ".cm-magic-markdown-refdef-kind-audio": {
        "--cm-magic-markdown-link-accent": "var(--cm-use-accent)",
    },
    ".cm-magic-markdown-refdef-kind-csv": {
        "--cm-magic-markdown-link-accent": "var(--cm-import-accent)",
    },
    ".cm-magic-markdown-refdef-kind-code": {
        "--cm-magic-markdown-link-accent": "var(--cm-render-accent)",
    },
    ".cm-magic-markdown-refdef-kind-pdf, .cm-magic-markdown-refdef-kind-asset": {
        "--cm-magic-markdown-link-accent": "var(--cm-meta-accent)",
    },
    ".cm-magic-markdown-refdef-key": {
        color: "inherit",
        textDecorationLine: "underline",
        textDecorationStyle: "dotted",
        textDecorationThickness: "0.08em",
        textDecorationColor:
            "color-mix(in srgb, var(--cm-magic-markdown-link-accent) 34%, transparent)",
        textUnderlineOffset: "0.16em",
    },
    ".cm-magic-markdown-refdef-arrow": {
        color: "color-mix(in srgb, var(--color-muted-foreground) 82%, transparent)",
        fontSize: "0.9em",
    },
    ".cm-magic-markdown-refdef-target": {
        minWidth: "0",
        overflowWrap: "anywhere",
        color: "inherit",
    },
    ".cm-magic-markdown-refdef-raw": {
        textDecorationLine: "underline",
        textDecorationStyle: "dotted",
        textDecorationThickness: "0.08em",
        textDecorationColor:
            "color-mix(in srgb, var(--content-link) 24%, transparent)",
        textUnderlineOffset: "0.16em",
    },
});
